__turbopack_context__.v({
  "actions": "not-found-module__16Mfwa__actions",
  "body": "not-found-module__16Mfwa__body",
  "crest": "not-found-module__16Mfwa__crest",
  "inner": "not-found-module__16Mfwa__inner",
  "message": "not-found-module__16Mfwa__message",
  "numeral": "not-found-module__16Mfwa__numeral",
  "page": "not-found-module__16Mfwa__page",
  "statement": "not-found-module__16Mfwa__statement",
  "title": "not-found-module__16Mfwa__title",
});
